module.exports = __webpack_public_path__ + "media/images/athletes/1863-39fa34f13a7a74051b0559f474d77aae.png";